import React from 'react';

/**
 * Обратный отсчёт в секундах.
 * `start(seconds)` запускает отсчёт заново, `left` тикает до нуля.
 * Ничего не сохраняет, для переживающего перезагрузку отсчёта
 * есть `usePersistedCountdown`.
 */
export default function useCountdown(): {
  left: number;
  active: boolean;
  start: (seconds: number) => void;
  stop: () => void;
} {
  const [deadline, setDeadline] = React.useState<number | null>(null);
  const [left, setLeft] = React.useState(0);

  React.useEffect(() => {
    if (deadline === null) return undefined;

    const tick = () => {
      const rest = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      setLeft(rest);
      if (rest === 0) setDeadline(null);
    };

    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [deadline]);

  const start = React.useCallback((seconds: number) => {
    if (seconds <= 0) {
      setDeadline(null);
      setLeft(0);
      return;
    }
    setLeft(seconds);
    setDeadline(Date.now() + seconds * 1000);
  }, []);

  const stop = React.useCallback(() => {
    setDeadline(null);
    setLeft(0);
  }, []);

  return {
    left, active: left > 0, start, stop,
  };
}

/** 65 -> 01:05 */
export function formatCountdown(seconds: number) {
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}
